import { Component } from 'react';

/**
 * Catches any unhandled React render errors and shows a friendly message
 * instead of a blank white screen.
 */
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="rounded-2xl border border-destructive/30 bg-destructive/5 p-6 space-y-3">
                    <div className="text-lg font-semibold text-destructive">Algo salió mal</div>
                    <p className="text-sm text-muted-foreground">
                        Ocurrió un error inesperado en esta sección. Intenta recargar la página.
                    </p>
                    {this.state.error?.message && (
                        <pre className="text-xs bg-muted rounded p-3 overflow-auto max-h-40 text-destructive/80">
                            {this.state.error.message}
                        </pre>
                    )}
                    <button
                        className="text-sm text-blue-600 underline"
                        onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
                    >
                        Recargar página
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
